import React from 'react';
import {ReactComponent as SquareEmpty} from '../../../assets/icons/square-empty.svg';
import {ReactComponent as SquareFilled} from '../../../assets/icons/square-filled.svg';

const Square = ({filled}) => {
  return <>{filled ? <SquareFilled /> : <SquareEmpty />}</>;
};

export default Square;
